Object.defineProperty(window, 'I', {
  value: window.I || {},
});

if (!window.I.gt) {
  Object.defineProperty(window.I, 'gt', {
    value: window.I.gt || { 
      __: (str) => str,
      __x: (str, args) => {
        if (!args) return string;
            return str.replace(/{([^}]+)}/g, function(match, value, offset, str) {
                if (typeof args[value] != 'undefined')
                    return args[value];
                else return match;
            });
        }                   
     },
  });
}

if (!window.I.MAM) {
  window.I.MAM = window.I.MAM || window.MAM;
}

const globals = {
  I: window.I,
  context: window,
};

export default globals;
